// @ngInject
function printLanguageConfirmationDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(message, level) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'printLanguageConfirmationDialogController as vm',
            templateUrl: 'services/dialogs/printLanguageConfirmationDialog/printLanguageConfirmationDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            message: function() {
                return message;
            },
            level: function() {
                return level;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function printLanguageConfirmationDialogController($uibModalInstance, $window, message, level, $sce, $translate) {
    var vm = this;

    //Properties
    vm.message = $sce.trustAsHtml(message);
    vm.level = level;
    vm.printLanguage = 'se';

    //Methods
    vm.closeModal = closeModal;
    vm.setLanguage = setLanguage;

    activate();

    function activate() {
        readSettingsFromLocalStorage();
    }

    function closeModal(isCompleted) {
        var result = {
            result: isCompleted,
            locale: vm.printLanguage
        };
        saveSettingsToLocalStorage();
        $uibModalInstance.close(result);
    }

    function setLanguage(language) {
        vm.printLanguage = language;
    }

    function readSettingsFromLocalStorage() {
        if ($window.localStorage.printLanguageConfirmationSettings) {
            if (!isJsonString($window.localStorage.getItem('printLanguageConfirmationSettings'))) {
                $window.localStorage.removeItem('printLanguageConfirmationSettings');
            }

            var settingsStr = $window.localStorage.getItem('printLanguageConfirmationSettings');
            if (settingsStr !== null) {
                var json = JSON.parse(settingsStr);
                if (json.printLanguage) { vm.printLanguage = json.printLanguage; }
            }
        }
    }
    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    function saveSettingsToLocalStorage() {
        var request = {
            printLanguage: angular.copy(vm.printLanguage)
        };

        $window.localStorage.setItem('printLanguageConfirmationSettings', JSON.stringify(request));
    }
}

angular
    .module('services.dialogs.printLanguageConfirmationDialog', [])
    .service('printLanguageConfirmationDialogService', printLanguageConfirmationDialogService)
    .controller('printLanguageConfirmationDialogController', printLanguageConfirmationDialogController);
